/**
 * Created by alvaroescarcha on 29/9/17.
 */

/// <reference path="../../typings/browser.d.ts" />

namespace Application.Controllers {
    'use strict';
    export class SystemAlarmsController {
        public static $name: string = "systemAlarmsController";
        constructor() {}
    }
}
